/* 🤖 this file was generated by svg-to-ts */
export const siriusSlidersHorizontalLightPictogram: {
  name: 'sliders_horizontal_light_pictogram';
  data: string;
} = {
  name: 'sliders_horizontal_light_pictogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;"><path d="M40.125 31.25h-4.258a4.873 4.873 0 0 0-9.484 0H7.125a1.125 1.125 0 1 0 0 2.25h19.258a4.874 4.874 0 0 0 9.485 0h4.257a1.125 1.125 0 1 0 0-2.25Zm-9 3.75a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25Zm-24-18h7.258a4.874 4.874 0 0 0 9.485 0h16.257a1.125 1.125 0 1 0 0-2.25H23.867a4.873 4.873 0 0 0-9.485 0H7.126a1.125 1.125 0 1 0 0 2.25Zm12-3.75a2.625 2.625 0 1 1 0 5.25 2.625 2.625 0 0 1 0-5.25Z" fill="currentColor"/></svg>`
};
